<style scoped>
.v-application .subtitle-1 {
  font-family: "Prompt", sans-serif !important;
}
.v-application .text-h5 {
  font-family: "Prompt", sans-serif !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-data-table__wrapper > table > thead > tr {
  background-color: #039be5;
}
.v-data-table__wrapper > table > thead > tr > th {
  font-size: 14px;
  color: white !important;
}
.v-input__slot {
  min-height: unset !important;
}
.right-input >>> input {
  text-align: right;
}
.handle {
  cursor: move;
}
</style>

<template>
  <div>
    <v-layout class="d-flex justify-space-between mb-5">
      <div
        class="text-h5 font-weight-black info--text text-spacing"
        color="blue"
      >
        ใบกำกับภาษี/ใบเสร็จรับเงินเลขที่ {{ header }}
      </div>
      <v-spacer></v-spacer>
      <v-btn color="white" elevation="0" large @click="back()" class="mr-4"
        >ยกเลิก</v-btn
      >
      <!--  -->
      <v-dialog v-model="dialog" max-width="640">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="success"
            elevation="0"
            large
            dark
            v-bind="attrs"
            v-on="on"
            v-if="!isEdit"
          >
            <v-icon left>mdi-file-plus</v-icon>บันทึกเอกสาร
          </v-btn>
        </template>
        <v-card>
          <v-card-title
            class="text-h5 font-weight-black info--text text-spacing"
            color="blue"
          >
            บันทึกเอกสาร {{ header }}
          </v-card-title>
          <v-card-text>
            <v-divider></v-divider>
            <v-row justify="center">
              <v-radio-group
                row
                class="mb-n5"
                v-model="sendOrsave"
                @change="genEmailDetail()"
              >
                <v-radio
                  class="pr-6"
                  label="บันทึกข้อมูลอย่างเดียว"
                  hide-details
                  value="NSEND"
                ></v-radio>
                <v-radio
                  class="pr-6"
                  label="ส่งอีเมลล์พร้อมกับบันทึก"
                  hide-details
                  value="SEND"
                ></v-radio>
              </v-radio-group>

              <v-col cols="12" lg="12" v-if="sendOrsave == 'SEND'">
                <v-row justify="center">
                  <v-col cols="12" lg="10" class="mb-n10 mt-n5">
                    <span class="email-text">จาก :</span>
                    <v-text-field
                      dense
                      outlined
                      v-model="Esender"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="10" class="mb-n10">
                    <span class="email-text">ถึง :</span>
                    <v-text-field
                      dense
                      outlined
                      v-model="Ereciever"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="10" class="mb-n10">
                    <span class="email-text">หัวข้อ :</span>
                    <v-text-field
                      dense
                      outlined
                      v-model="Eheader"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="10" class="my-n2"> </v-col>
                  <v-col cols="12" lg="10" class="mt-n2">
                    <span class="email-text">ข้อความ :</span>
                    <v-textarea
                      row-height="5"
                      dense
                      outlined
                      v-model="Emessage"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" lg="10" class="mt-n5">
                    <v-btn color="primary" width="100%" @click="sendemail()">
                      ส่งอีเมลล์พร้อมกับบันทึก
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" lg="12" v-else>
                <v-btn color="success" width="100%" @click="insert_data()">
                  บันทึกข้อมูล
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-btn
        color="success"
        elevation="0"
        large
        dark
        @click="edit()"
        v-if="isEdit"
      >
        <v-icon left>mdi-file-plus</v-icon>แก้ไขเอกสาร
      </v-btn>
    </v-layout>
    <v-divider class="mt-n1 mb-3"></v-divider>
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-layout class="d-flex justify-space-between mb-15">
        <v-row>
          <!-- :items="Find_CustomerName" -->
          <v-col cols="12" lg="4" class="mb-n8">
            <v-combobox
              :disabled="isEdit || spliting"
              label="เลือกลูกค้า"
              dense
              outlined
              :items="list_customer"
              item-text="CUSTOMER_NAME"
              item-value="NEWCUSTOMER_ID"
              return-object
              required
              v-model="vCustomer_Name"
              @change="(event) => select_customer(event)"
            ></v-combobox>
          </v-col>
          <v-col cols="12" lg="8" class="mb-n11">
            <v-spacer></v-spacer>
          </v-col>
          <v-col cols="12" lg="4" class="mb-n10">
            <v-text-field
              label="เลขประจำตัวผู้เสียภาษี"
              dense
              outlined
              v-model="vCustomer_Tax"
              :disabled="isEdit || spliting"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="8" class="mb-n11">
            <v-spacer></v-spacer>
          </v-col>
          <v-col cols="12" lg="4" class="mb-n10">
            <v-text-field
              label="สำนักงาน / สาขาเลขที่"
              dense
              outlined
              v-model="vCustomer_Branch"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="8" class="mb-n11">
            <v-spacer></v-spacer>
          </v-col>
          <v-col cols="12" lg="4" class="mb-n10">
            <v-text-field
              label="ที่อยู่"
              dense
              outlined
              v-model="vcus_address"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="8" class="mb-n7">
            <v-spacer></v-spacer>
          </v-col>
          <v-col cols="12" lg="2" class="mb-n7">
            <addressinput-subdistrict v-model="cus_pro" />
          </v-col>
          <!-- <v-col cols="12" lg="8" class="mb-n7">
            <v-spacer></v-spacer>
          </v-col>-->
          <v-col cols="12" lg="2" class="mb-n7">
            <addressinput-district v-model="cus_dis" />
          </v-col>
          <v-col cols="12" lg="8" class="mb-n7">
            <v-spacer></v-spacer>
          </v-col>

          <v-col cols="12" lg="2" class="mb-n7">
            <addressinput-province v-model="cus_subdis" />
          </v-col>
          <v-col cols="12" lg="2" class="mb-n7">
            <addressinput-zipcode v-model="cus_zip" />
          </v-col>
          <v-col cols="12" lg="8">
            <v-spacer></v-spacer>
          </v-col>

          <!-- <v-col cols="12" lg="6" class="mb-n10">
            <v-text-field label="รหัสไปรษณีย์" dense single-line outlined></v-text-field>
          </v-col>-->
          <!-- <v-col cols="12" lg="6" class="mb-n11">
            <v-spacer></v-spacer>
          </v-col>-->
        </v-row>
        <v-spacer></v-spacer>

        <v-row style="justify-content: flex-end">
          <v-col cols="12" lg="12" class="mb-2">
            <v-layout class="d-flex flex-row-reverse mb-n15">
              <div class="d-flex flex-column align-center" style="width: 80px">
                <v-btn icon height="30" xLarge>
                  <v-icon>mdi-email-send-outline</v-icon>
                </v-btn>
                <p class="mb-0" style="font-size: 12px">ส่งอีเมลล์</p>
              </div>
              <div class="d-flex flex-column align-center" style="width: 80px">
                <v-btn icon height="30" xLarge @click="downloadPdf()">
                  <v-icon>mdi-download</v-icon>
                </v-btn>
                <p class="mb-0" style="font-size: 12px">ดาวน์โหลด</p>
              </div>
              <div class="d-flex flex-column align-center" style="width: 80px">
                <v-dialog v-model="dialog2" max-width="550">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon height="30" xLarge v-bind="attrs" v-on="on">
                      <v-icon>mdi-printer</v-icon>
                    </v-btn>
                    <p class="mb-0" style="font-size: 12px">พิมพ์เอกสาร</p>
                  </template>
                  <v-card>
                    <v-card-title
                      class="text-h5 font-weight-black info--text text-spacing"
                      color="blue"
                    >
                      พิมพ์เอกสาร {{ header }}
                    </v-card-title>
                    <v-card-text>
                      <v-divider></v-divider>
                      <v-row justify="center">
                        <v-col cols="12" lg="12">
                          <v-btn
                            color="primary"
                            width="100%"
                            @click="printPdf()"
                          >
                            พิมพ์เอกสาร
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </div>
            </v-layout>
          </v-col>

          <v-col cols="12" lg="8">
            <div class="subtitle-1 font-weight-bold">จำนวนรวมทั้งสิ้น</div>
            <div class="text-h5 info--text font-weight-bold">
              {{ totalVat7 | delimeter }}
            </div>
          </v-col>
          <v-col cols="12" lg="2">
            <v-spacer></v-spacer>
          </v-col>
          <v-col cols="12" lg="4" class="my-n9 text-right">
            <div class="subtitle-1 font-weight-bold">วันที่</div>
          </v-col>
          <v-col cols="12" lg="8" class="my-n10 text-right">
            <date-picker
              color="black"
              class="mb-1"
              style="width: 100%"
              v-model="con_date"
              :format="momentFormat"
            ></date-picker>
          </v-col>
        </v-row>
      </v-layout>
      <v-divider class="mt-n1 mb-3"></v-divider>
      <v-row>
        <v-col cols="12" lg="1">
          <div class="subtitle-1 font-weight-bold mt-1">ชื่อโปรเจค</div>
        </v-col>
        <v-col cols="12" lg="4">
          <v-text-field outlined dense v-model="vcus_memo"></v-text-field>
        </v-col>
        <v-col cols="12" lg="1">
          <div class="subtitle-1 font-weight-bold mt-1">เลขที่อ้างอิง</div>
        </v-col>
        <v-col cols="12" lg="2" v-if="isEdit || spliting || isListmenu">
          <v-text-field
            outlined
            dense
            v-model="b_reference"
            :disabled="isEdit || spliting"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="2" v-else>
          <v-select
            outlined
            dense
            :items="list_ref"
            item-text="REFID"
            item-value="REFID"
            clearable
            v-model="b_reference"
            @change="(event) => change_ref(event)"
            :disabled="isEdit || spliting"
          ></v-select>
        </v-col>
        <v-col cols="12" lg="1">
          <div class="subtitle-1 font-weight-bold mt-1">ราคาสินค้า</div>
        </v-col>
        <v-col cols="12" lg="3">
          <v-select
            label="เลือกราคา"
            :items="pricing"
            dense
            outlined
            v-model="price_op"
            @change="(event) => price_option(event)"
            :disabled="isEdit || spliting"
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" lg="12" class="mt-n3">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" style="width: 3%">ลำดับ</th>
                  <th class="text-left" style="width: 55%">
                    ชื่อสินค้า / รายละเอียด
                  </th>
                  <th class="text-left" style="width: 3%">จำนวน</th>
                  <th class="text-left" style="width: 3%">หน่วย</th>
                  <th class="text-left" style="width: 12%">ราคาต่อหน่วย</th>
                  <th class="text-left" style="width: 12%">ราคารวม</th>
                  <th class="text-center" style="width: 2%"></th>
                </tr>
              </thead>
              <draggable
                :list="product_list"
                tag="tbody"
                :move="onMove(product_list)"
              >
                <tr
                  v-for="(item, index) in product_list"
                  :key="index"
                  class="handle"
                >
                  <td>{{ index + 1 }}</td>
                  <td>
                    <v-menu offset-y :disabled="isEdit || spliting">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :disabled="isEdit || spliting"
                          v-on="on"
                          clearable
                          placeholder="สินค้า"
                          flat
                          class="mt-2 mb-1"
                          dense
                          v-model="product_list[index].NAME"
                          @keyup="search = $event.target.value"
                          @click:clear="clearSearch()"
                        ></v-text-field>
                      </template>
                      <v-list style="max-height: 200px; overflow: auto">
                        <v-list-item
                          v-for="(item, i) in filteredItems"
                          :key="i"
                          @click="select_combo(index, item)"
                        >
                          <v-list-item-title>{{ item.NAME }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                      <!-- <v-card>
                        <v-divider></v-divider>
                        <div class="pa-1" @click.stop>
                          <v-btn
                            text
                            dark
                            small
                            color="primary"
                            depressed
                            :ripple="false"
                            style="width: 100%; justify-content: start"
                          >
                            <v-icon left>mdi-plus</v-icon>เพิ่มสินค้า
                          </v-btn>
                        </div>
                      </v-card> -->
                    </v-menu>
                    <v-textarea
                      placeholder="รายละเอียด"
                      dense
                      outlined
                      rows="1"
                      row-height="5"
                      auto-grow
                      class="my-n4"
                      v-model="product_list[index].DETAIL"
                    ></v-textarea>
                  </td>
                  <td>
                    <v-text-field
                      dense
                      class="mt-3"
                      type="number"
                      v-model="product_list[index].AMOUT"
                      @keyup="changeUnit()"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      dense
                      class="mt-3"
                      :disabled="isEdit || spliting"
                      v-model="product_list[index].UNIT"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      dense
                      class="mt-3"
                      v-model="product_list[index].PRICE"
                      @keyup="changePrice()"
                    ></v-text-field>
                  </td>

                  <td style="font-size: 1rem">
                    {{ sumCol(index) | delimeter }}
                  </td>
                  <td>
                    <v-btn
                      icon
                      @click="delete_product(item)"
                      v-if="!isEdit"
                      :disabled="spliting"
                    >
                      <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </draggable>
              <v-spacer></v-spacer>
            </template>
          </v-simple-table>
        </v-col>
        <v-col cols="12" lg="3">
          <v-btn
            color="info"
            elevation="0"
            :disabled="spliting"
            large
            @click="add_product()"
            v-if="!isEdit"
          >
            <v-icon left>mdi-plus</v-icon>เพิ่มแถวรายการ
          </v-btn>
        </v-col>
      </v-row>

      <v-layout class="d-flex justify-space-between mb-15">
        <v-row>
          <v-col cols="12" lg="12" class="mb-n2">
            <div class="subtitle-1 font-weight-bold">หมายเหตุ</div>
          </v-col>
          <v-col cols="12" lg="12" class="my-n5">
            <v-textarea
              label
              outlined
              rows="3"
              row-height="25"
              v-model="remark"
            ></v-textarea>
          </v-col>
          <!-- <v-col cols="12" lg="3" class="my-n5">
            <v-spacer></v-spacer>
          </v-col>-->
          <!-- <v-col cols="12" lg="12" class="my-n2">
            <div class="subtitle-1 font-weight-bold">โน๊ตภายในบริษัท</div>
          </v-col>
          <v-col cols="12" lg="7" class="my-n5">
            <v-textarea label outlined rows="3" row-height="25"></v-textarea>
          </v-col>
          <v-col cols="12" lg="5" class="my-n5">
            <v-spacer></v-spacer>
          </v-col>
          <v-col cols="12" lg="7" class="my-n5">
            <v-text-field outlined label="แนบไฟล์" dense prepend-inner-icon="mdi-plus"></v-text-field>
          </v-col>
          <v-col cols="12" lg="5" class="my-n5">
            <v-spacer></v-spacer>
          </v-col>-->
          <!-- <v-col cols="12" lg="12" class="my-n8">
            <v-checkbox label="ลายเซ็นอิเล็กทรอนิกส์และตรายาง" v-model="signature"></v-checkbox>
          </v-col>-->
        </v-row>

        <v-spacer></v-spacer>

        <v-row style="justify-content: flex-end; width: 100%">
          <v-col cols="12" lg="12" class="my-n10 text-right">
            <div class="d-flex flex-column mb-6">
              <div class="d-flex flex-row-reverse">
                <div class="subtitle-1 font-weight-bold ml-15 my-1">
                  {{ summary | delimeter }}
                </div>
                <div class="subtitle-1 font-weight-bold info--text mr-15 my-1">
                  รวมเป็นเงิน
                </div>
              </div>
              <div class="d-flex flex-row-reverse" v-if="isSplit">
                <div class="subtitle-1 font-weight-bold ml-15 mt-8">
                  {{ splitPrice | delimeter }}
                </div>
                <div class="subtitle-1 font-weight-bold info--text mr-15 mt-5">
                  <span>แบ่งชำระ</span>
                  <span style="display: inline-block">
                    <v-select
                      dense
                      :items="['เปอร์เซ็นต์', 'จำนวนเงิน']"
                      :disabled="spliting || isEdit"
                      style="width: 110px"
                      class="mt-2 ml-2"
                      v-model="sp_option"
                      @change="(evt) => split_option(evt)"
                    ></v-select>
                  </span>
                  <span style="display: inline-block">
                    <v-text-field
                      dense
                      label="จำนวน"
                      style="width: 80px"
                      type="number"
                      class="mt-2 ml-2"
                      v-model="split_value"
                      @keyup="keySplitValue()"
                    ></v-text-field>
                  </span>
                </div>
              </div>
              <div
                class="d-flex flex-row-reverse"
                v-if="vat_option == 'ราคารวมภาษี'"
              >
                <div class="subtitle-1 font-weight-bold ml-15 my-1">
                  {{ totalVat7 | delimeter }}
                </div>
                <div class="subtitle-1 font-weight-bold info--text mr-15 my-1">
                  จำนวนเงินรวมทั้งสิ้น
                </div>
              </div>

              <div class="d-flex flex-row-reverse">
                <div class="subtitle-1 font-weight-bold ml-15 my-5">
                  {{ onlyVat7 | delimeter }}
                </div>
                <div class="subtitle-1 font-weight-bold info--text mr-15">
                  <v-checkbox
                    label="ภาษีมูลค่าเพิ่ม 7%"
                    v-model="vat7"
                    v-if="vat_option == 'ราคาไม่รวมภาษี'"
                    @change="(evt) => checked_vat7(evt)"
                  ></v-checkbox>
                  <div class="mt-4" v-else-if="vat_option == 'ราคารวมภาษี'">
                    ภาษีมูลค่าเพิ่ม 7%
                  </div>
                  <!-- <v-checkbox label="ภาษีมูลค่าเพิ่ม 7%" v-model="vat7" v-else></v-checkbox> -->
                </div>
              </div>
              <div
                class="d-flex flex-row-reverse"
                v-if="vat_option == 'ราคารวมภาษี'"
              >
                <div class="subtitle-1 font-weight-bold ml-15 my-1">
                  {{ exclude_7 | delimeter }}
                </div>
                <div class="subtitle-1 font-weight-bold info--text mr-15 my-1">
                  ราคาไม่รวมภาษีมูลค่าเพิ่ม
                </div>
              </div>

              <div
                class="d-flex flex-row-reverse"
                v-if="vat_option == 'ราคาไม่รวมภาษี'"
              >
                <div class="subtitle-1 font-weight-bold ml-15">
                  {{ totalVat7 | delimeter }}
                </div>
                <div class="subtitle-1 font-weight-bold info--text mr-15">
                  จำนวนเงินรวมทั้งสิ้น
                </div>
              </div>

              <div class="d-flex flex-row-reverse mt-4 mb-3">
                <div class="subtitle-1 font-weight-bold ml-2 mt-5">
                  <v-text-field
                    v-if="is_discount"
                    dense
                    style="width: 80px"
                    type="number"
                    class="mt-2 ml-2 right-input"
                    v-model="discount_value"
                    @keyup="(evt) => keyDiscount(evt)"
                  ></v-text-field>
                  <div v-else style="width: 80px"></div>
                </div>
                <div class="subtitle-1 font-weight-bold info--text mr-15 mt-2">
                  <span style="display: inline-block">
                    <v-checkbox
                      :label="is_discount ? '' : 'เพิ่มรายการปรับลด'"
                      v-model="is_discount"
                      @change="(evt) => change_discount(evt)"
                    ></v-checkbox>
                  </span>
                  <span style="display: inline-block">
                    <v-select
                      v-if="is_discount"
                      dense
                      :items="[
                        'ส่วนลดพิเศษ',
                        'ค่านายหน้า/ส่วนแบ่งการขาย',
                        'ค่าดำเนินการ',
                        'ปัดเศษ',
                      ]"
                      style="width: 150px"
                      class="mt-2 ml-2"
                      v-model="discount_type"
                    ></v-select>
                  </span>
                </div>
              </div>
              <div class="d-flex flex-row-reverse mt-n6">
                <div class="subtitle-1 font-weight-bold ml-15 my-3">
                  <span v-if="isVat3"> {{ onlyVat3 | delimeter }}</span>
                </div>
                <div class="subtitle-1 font-weight-bold info--text mr-15">
                  <v-row align="center">
                    <v-checkbox
                      label="หักภาษี ณ ที่จ่าย"
                      v-model="vat3"
                      @change="(evt) => checked_vat3(evt)"
                    ></v-checkbox>
                    <v-select
                      v-if="isVat3"
                      dense
                      :items="se_vat3"
                      style="width: 80px"
                      class="mt-2 ml-2"
                      v-model="vat3_value"
                      @change="(evt) => vat3_option(evt)"
                    ></v-select>
                  </v-row>
                </div>
              </div>
              <div class="d-flex flex-row-reverse" v-if="isVat3 || is_discount">
                <div class="subtitle-1 font-weight-bold ml-15">
                  {{ actual_pay | delimeter }}
                </div>
                <div class="subtitle-1 font-weight-bold info--text mr-15">
                  ยอดชำระ
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-layout>
    </v-form>
  </div>
</template>

<script>
import pdfMake from "@/assets/build/pdfmake";
import pdfFonts from "@/assets/build/vfs_fonts";
import printJS from 'print-js'
import invoice_pdf from "../pdf/invoice";
import draggable from "vuedraggable";
import { mapMutations, mapGetters } from 'vuex'
import moment from 'moment';
import { parse } from 'path';
export default {
  name: "InvoiceForm",
  components: {

    draggable
  },
  data: () => ({
    isEdit: false,
    isListmenu: false,
    Esender: "newchok.2019@gmail.com",
    Emessage: "",
    previousRoute: "",
    Eheader: "",
    list_ref: [],
    header: "",
    momentFormat: {
      // Date to String
      stringify: (date) => {
        return date
          ? moment(date).add(543, "year").locale("th").format("LL")
          : "";
      },
      // String to Date
      parse: (value) => {
        return value ? moment(value, "LL").toDate() : null;
      },
    },
    splitPrice: 0,
    sp_option: "เปอร์เซ็นต์",
    split_value: 0,
    isSplit: false,
    checkReciept: "",
    sendOrsave: "NSEND",
    enabled_tax: false,
    enabled_c_date: false,
    v_cal_tax: [(v) => !!v || ""],
    v_percent_tax: [(v) => !!v || ""],
    v_collect_date: [(v) => !!v || ""],
    v_waste_document: [(v) => !!v || ""],
    v_c_period: [(v) => !!v || "กรุณาเลือกจำนวนปี"],
    v_hopsname: [(v) => !!v || "กรุณากรอกสถานบริการ"],
    v_c_start: [(v) => !!v || "กรุณาเลือกวันที่ทำสัญญา"],
    v_c_type: [(v) => !!v || "กรุณาเลือกอัตราการจัดเก็บขยะ"],
    contract_period: [],
    se_vat3: ["3%", "5%", "0.5%", "0.75%", "1%"],
    list_customer: [],
    pricing: ["ราคาไม่รวมภาษี"],
    product: [],
    search: "",
    vat_option: "ราคาไม่รวมภาษี",
    isVat3: false,
    spliting: false,
    summaryVat3: 0,
    dialog: false,
    totalVat7: 0,
    onlyVat7: 0,
    onlyVat3: 0,
    summary: 0.0,
    exclude_7: 0,
    dialog2: false,
    actual_pay: 0,
    valid: true,
    lazy: false,
    se_contract: "",
    c_type: ["เหมาจ่ายรายปี", "เหมาจ่ายรายเดือน", "คิดเป็นหน่วย / กิโลกรัม"],
    valid: true,
    lazy: false,
    Find_CustomerName: "",

  }),
  filters: {
    delimeter(data) {
      let y = parseFloat(data).toFixed(2)
      let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      return x

    },
    formatDate(data) {
      return moment(data).format('DD-MM-YYYY')
    }
  },
  computed: {
    ...mapGetters({
      GET_INVOICE: "Invoice/GET_INVOICE",
      GET_PRODUCT: "Invoice/GET_PRODUCT",
    }),
    filteredItems() {
      let searchRegExp = new RegExp(this.search, "gi");
      return this.product.filter((item) => {
        if (!this.search) {
          return this.product;
        } else {
          return searchRegExp.test(item.NAME);
        }
      });
    },
    product_list() {
      let vat3 = this.GET_INVOICE.ISVAT2;
      let vat7 = this.GET_INVOICE.ISVAT;
      let sp_option = this.sp_option

      this.sumProductValue(vat7, vat3, sp_option);
      let list_product = this.GET_PRODUCT;
      list_product.filter((x) => { return x.PRICE == null }).map((item) => { return item.PRICE = 0 });
      return list_product;
    },
    discount_value: {
      get() { return this.GET_INVOICE.DISCOUNT_VALUE; },
      set(value) {
        this.SET_ELEM({ key: "DISCOUNT_VALUE", value: value });
      },
    },
    discount_type: {
      get() { return this.GET_INVOICE.DISCOUNT_TYPE; },
      set(value) {
        this.SET_ELEM({ key: "DISCOUNT_TYPE", value: value });
      }
    },
    is_discount: {
      get() { return this.GET_INVOICE.IS_DISCOUNT; },
      set(value) {
        this.SET_ELEM({ key: "IS_DISCOUNT", value: value });
      }
    },
    Ereciever: {
      get() {
        return this.GET_INVOICE.PROVIDER_EMAIL;
      },
      set(value) {
        this.SET_ELEM({
          key: "PROVIDER_EMAIL",
          value: value,
        });
      },
    },
    vcus_memo: {
      get() {
        return this.GET_INVOICE.MEMO;
      },
      set(value) {
        this.SET_ELEM({
          key: "MEMO",
          value: value,
        });
      },
    },
    vcus_address: {
      get() {
        return this.GET_INVOICE.CUSTOMER_ADDRESS;
      },
      set(value) {
        this.SET_ELEM({
          key: "CUSTOMER_ADDRESS",
          value: value,
        });
      },
    },
    price_op: {
      get() {
        return this.GET_INVOICE.PRICE_OPTION;
      },
      set(value) {
        this.SET_ELEM({
          key: "PRICE_OPTION",
          value: value,
        });
      },
    },
    remark: {
      get() {
        return this.GET_INVOICE.REMARK;
      },
      set(value) {
        this.SET_ELEM({
          key: "REMARK",
          value: value,
        });
      },
    },
    vat7: {
      get() {
        return this.GET_INVOICE.ISVAT;
      },
      set(value) {
        this.SET_ELEM({
          key: "ISVAT",
          value: value,
        });
      },
    },
    vat7_value: {
      get() {
        return this.GET_INVOICE.VAT_VALUE;
      },
      set(value) {
        this.SET_ELEM({
          key: "VAT_VALUE",
          value: value,
        });
      },
    },
    vat3: {
      get() {
        return this.GET_INVOICE.ISVAT2;
      },
      set(value) {
        this.SET_ELEM({
          key: "ISVAT2",
          value: value,
        });
      },
    },
    vat3_value: {
      get() {
        return this.GET_INVOICE.VAT_VALUE2;
      },
      set(value) {
        this.SET_ELEM({
          key: "VAT_VALUE2",
          value: value,
        });
      },
    },
    signature: {
      get() {
        return this.GET_INVOICE.SIGNATURE;
      },
      set(value) {
        this.SET_ELEM({
          key: "SIGNATURE",
          value: value,
        });
      },
    },
    b_reference: {
      get() {

        return this.GET_INVOICE.BILL_ID;

      },
      set(value) {
        this.SET_ELEM({ key: "BILL_ID", value: value });
      },
    },
    con_date: {
      get() {
        return this.GET_INVOICE.CREATED_AT ? new Date(this.GET_INVOICE.CREATED_AT) : new Date();
      },
      set(value) {
        this.SET_ELEM({
          key: "CREATED_AT",
          value: value,
        });


      },
    },
    cus_pro: {
      get() {
        return this.GET_INVOICE.CUSTOMER_PROVINCE;
      },
      set(value) {
        this.SET_ELEM({
          key: "CUSTOMER_PROVINCE",
          value: value,
        });
      },
    },
    cus_dis: {
      get() {
        return this.GET_INVOICE.CUSTOMER_DISTRICT;
      },
      set(value) {
        this.SET_ELEM({
          key: "CUSTOMER_DISTRICT",
          value: value,
        });
      },
    },
    cus_subdis: {
      get() {
        return this.GET_INVOICE
          .CUSTOMER_SUBDISTRICT;
      },
      set(value) {
        this.SET_ELEM({
          key: "CUSTOMER_SUBDISTRICT",
          value: value,
        });
      },
    },
    cus_zip: {
      get() {
        return this.GET_INVOICE.CUSTOMER_ZIPCODE;
      },
      set(value) {
        this.SET_ELEM({
          key: "CUSTOMER_ZIPCODE",
          value: value,
        });
      },
    },
    //auto com by Bee
    vCustomer_Name: {
      get() {
        return this.GET_INVOICE.CUSTOMER_NAME;
      },
      set(value) {
        this.SET_ELEM({
          key: "CUSTOMER_ID",
          value: value.NEWCUSTOMER_ID,
        });
      },
    },
    vCustomer_Tax: {
      get() {
        return this.GET_INVOICE.CUSTOMER_TAX_ID;
      },
      set(value) {
        this.SET_ELEM({
          key: "CUSTOMER_TAX_ID",
          value: value,
        });
      },
    },
    vCustomer_Branch: {
      get() {
        return this.GET_INVOICE.CUSTOMER_BRANCH;
      },
      set(value) {
        this.SET_ELEM({
          key: "CUSTOMER_BRANCH",
          value: value,
        });
      },
    },
  },
  mounted() {
    if (!this.$store.getters['Invoice/IS_EDIT']) {
      this.quotationHeader();

    } else {
      this.header = this.GET_INVOICE.INVOICE_ID
      this.isEdit = true

    }
    this.isListmenu = this.$store.getters['Invoice/IS_MENU']


  },
  created() {
    this.checkReciept = "WR"
    const _this = this
    this.price_op = this.pricing[0]
    // console.log(this.GET_INVOICE)
    let p_sp_val = _this.GET_INVOICE.PREVIOUS_VALUE

    setTimeout(() => {
      _this.split_value = _this.GET_INVOICE.SPLIT_VALUE
      _this.isVat3 = _this.GET_INVOICE.ISVAT2 == 1 ? true : false
      _this.isSplit = _this.GET_INVOICE.SPLIT_PAY == 1 ? true : false
      _this.spliting = _this.$store.getters["Invoice/SPLITING"] ? true : false
      _this.sp_option = _this.GET_INVOICE.SPLIT_OPTION

    }, 1000)
    // console.log(this.split_value)
    this.$token_api
      .get("/list-customer")
      .then((response) => {
        this.list_customer = response.data.data;
      })
      .catch((err) => { });
    this.list_product();

  },
  methods: {
    ...mapMutations({
      LOADER: "Drawer/SET_LOADER",
      SET_ELEM: "Invoice/SET_ELEMENT",
      SET_ALL_ELEM: "Invoice/SET_ALL_ELEMENT",
      SET_PRODUCT: "Invoice/SET_PRODUCT_LIST"
    }),
    onMove(item) {
      this.SET_PRODUCT(item)

    },
    getPreviousRoute(from) {
      this.previousRoute = from
    },
    genEmailDetail() {
      this.Eheader = 'เอกสารกำกับภาษี ' + this.header + ''
      this.Emessage = `เรียน  ${this.vCustomer_Name}${'\n'}${'\n'}${this.$AppName.limited_company} ได้แนบเอกสาร เลขที่ ${this.header} มาให้ในอีเมลนี้${'\n'}${'\n'}กรุณาคลิกที่ไฟล์แนบ เพื่อดาวน์โหลดเอกสารของคุณ${'\n'}${'\n'}ท่านสามารถชำระค่าใช้จ่ายและดูรายงานการเก็บขนได้โดยผ่านลิงค์ดังกล่าว${'\n'}${this.$global_link}/Customer/${this.GET_INVOICE.CUSTOMER_ID}${'\n'}${'\n'}ท่านสามารถแอดไลน์เพื่อติดตามการเก็บขนได้โดยคลิ๊กลิงค์ดังกล่าว${'\n'}https://line.me/R/oaMessage/@328royru/link_${this.GET_INVOICE.CUSTOMER_ID}${'\n'}${'\n'}${'\n'}${'\n'}ด้วยความเคารพ ${this.$AppName.limited_company}`
    },
    split_option(item) {
      let vat3 = this.GET_INVOICE.ISVAT2;
      let vat7 = this.GET_INVOICE.ISVAT;
      let sp_option = item
      this.sumProductValue(vat7, vat3, sp_option);
    },
    async change_ref(item) {
      this.LOADER(true);
      let response = await this.$token_api
        .post("/get-bill-by-id", {
          BILL_ID: item,
        })
        .catch((err) => {
          this.LOADER(false);
        });

      let data = response.data.data;
      if (data.length > 0) {
        const prod_detail = await new Response(data[0].PRODUCT_LIST).json();
        this.SET_PRODUCT(prod_detail);
        this.LOADER(false);
      } else {
        this.LOADER(false);
      }
    },
    keyDiscount() {
      let vat7_val = this.totalVat7
      let vat3_val = this.summaryVat3
      let discount = this.GET_INVOICE.DISCOUNT_VALUE
      // console.log(vat3_val)

      if (this.vat7 && !this.vat3) {
        this.actual_pay = parseFloat(vat7_val - discount)
      } else if (this.vat7 && this.vat3) {
        this.actual_pay = parseFloat(vat3_val - discount)
      } else if (!this.vat7 && this.vat3) {
        this.actual_pay = parseFloat(vat3_val - discount)
      } else {
        this.actual_pay = parseFloat(vat7_val - discount)
      }
    },
    change_discount(item) {
      let vat3 = this.GET_INVOICE.ISVAT2;
      let vat7 = this.GET_INVOICE.ISVAT;
      let sp_option = this.sp_option
      this.actual_pay = 0
      this.sumProductValue(vat7, vat3, sp_option);
      if (item) {
        this.SET_ELEM({ key: "DISCOUNT_TYPE", value: "ส่วนลดพิเศษ" })
      } else {
        this.SET_ELEM({ key: "DISCOUNT_TYPE", value: "" })
      }

      this.SET_ELEM({ key: "DISCOUNT_VALUE", value: "" })

    },
    keySplitValue() {
      let vat3 = this.GET_INVOICE.ISVAT2;
      let vat7 = this.GET_INVOICE.ISVAT;
      let sp_option = this.sp_option

      this.sumProductValue(vat7, vat3, sp_option);
    },
    async sendemail() {
      const _this = this
      _this.LOADER(true)
      let data = this.GET_INVOICE
      data.DOC_DATE = moment(data.CREATED_AT).format("DD/MM/YYYY")
      data.INVOICE_ID = this.header
      data.TOTAL_PRICE = this.summary
      data.TVAT_VALUE = this.onlyVat7
      data.TOTAL = this.totalVat7
      let product = this.GET_PRODUCT
      let invoice_list = {
        INVOICE_ID: this.header,
        DATA: data,
        PACKAGE: product,
      };
      let email_obj = {
        INVOICE_ID: this.header,
        email_sender: this.Esender,
        email_reciever: this.Ereciever,
        email_header: this.Eheader,
        email_content: this.Emessage,
        pdf_file: "",
        file_name: "",
      }
      if (this.check_split_value()) {
        this.$token_api.post("/insert-duplicate-invoice", invoice_list)
          .then((response) => {
            this.$token_api.post("/send-invoice-email", email_obj)
              .then((response) => {
                this.$swal({
                  title: "สำเร็จ",
                  text: "สร้างใบกำกับภาษี/ใบเสร็จรับเงิน",
                  timer: 2000,
                  icon: "success"
                }).then((res) => {
                  // this.$store.dispatch("Quotation/reset");
                  // this.quotationHeader()

                  this.LOADER(false)
                  this.dialog = false
                  this.back()
                });
              }).catch((err) => {
                this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
                this.LOADER(false)
              });
          })

          .catch((err) => {
            this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
            this.LOADER(false)
          });
      }
    },
    async printPdf() {
      let data = this.GET_INVOICE
      let product = this.GET_PRODUCT
      data.DOC_DATE = moment(data.CREATED_AT).format("DD/MM/YYYY")
      data.INVOICE_ID = this.header
      data.TOTAL_PRICE = this.summary
      data.TVAT_VALUE = this.onlyVat7
      data.TOTAL = this.totalVat7

      let invoice_list = {
        INVOICE_ID: this.header,
        DATA: data,
        PACKAGE: product,
      };
      this.LOADER(true)

      if (this.check_split_value()) {
        this.$token_api.post("/insert-duplicate-invoice", invoice_list)
          .then((response) => {
            this.$swal({
              title: "สำเร็จ",
              text: "สร้างใบกำกับภาษี/ใบเสร็จรับเงิน",
              timer: 2000,
              icon: "success"
            }).then((res) => {
              this.$download_api.get(`/donwload-invoice/${this.header}`).then((response) => {
                if (window.navigator.msSaveOrOpenBlob) {
                  window.navigator.msSaveOrOpenBlob(response.data, 'ใบกำกับภาษี_' + this.header + '.pdf'); //IE is the worst!!!
                } else {
                  const url = window.URL.createObjectURL(new Blob([response.data]));
                  printJS(url)
                }
                this.dialog2 = false
                this.LOADER(false)
              }).catch((err) => {
                this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
                this.LOADER(false)
              });
              this.LOADER(false)
            });

          }).catch((err) => {
            this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
            this.LOADER(false)
          });
      }

    },
    async downloadPdf() {
      let data = this.GET_INVOICE
      let product = this.GET_PRODUCT
      data.DOC_DATE = moment(data.CREATED_AT).format("DD/MM/YYYY")
      data.INVOICE_ID = this.header
      data.TOTAL_PRICE = this.summary
      data.TVAT_VALUE = this.onlyVat7
      data.TOTAL = this.totalVat7
      let invoice_list = {
        INVOICE_ID: this.header,
        DATA: data,
        PACKAGE: product,
      };
      this.LOADER(true)
      if (this.check_split_value()) {
        this.$token_api.post("/insert-duplicate-invoice", invoice_list)
          .then((response) => {
            this.$swal({
              title: "สำเร็จ",
              text: "สร้างใบกำกับภาษี/ใบเสร็จรับเงิน",
              timer: 2000,
              icon: "success"
            }).then((res) => {
              this.$download_api.get(`/donwload-invoice/${this.header}`).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'ใบกำกับภาษี_' + this.header + '.pdf');
                document.body.appendChild(link);
                link.click();
                this.LOADER(false)
              }).catch((err) => {
                this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
                this.LOADER(false)
              });
              this.LOADER(false)
            });

          }).catch((err) => {
            this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
            this.LOADER(false)
          });
      }
    },
    quotationHeader() {

      this.$token_api
        .get("/get-invoice-id")
        .then((response) => {
          this.header = response.data.data[0].invoice_id;
          this.SET_ELEM({ key: "INVOICE_ID", value: response.data.data[0].invoice_id })
        })
        .catch((err) => { });

    },
    clearSearch() {
      this.search = "";
    },
    select_combo(i, item) {
      // console.log(item)
      this.product_list[i].PID = item.PID;
      this.product_list[i].NAME = item.NAME;
      this.product_list[i].UNIT = item.UNIT;
      this.product_list[i].DETAIL = item.DETAIL;
      this.product_list[i].PRICE = item.PRICE;
      let product = this.GET_PRODUCT;
      var valueArr = product.map(function (x) { return x.PID });
      var isDuplicate = valueArr.some(function (item, idx) {
        return valueArr.indexOf(item) != idx
      });
      if (isDuplicate) {
        this.$swal({
          title: "กรุณากรอกข้อมูลใหม่",
          text: "พบรายการสินค้าซ้ำ",
          timer: 2000,
          icon: "warning"
        }).then((res) => {
          this.$store.dispatch("Quotation/remove_product_list", item);
        });
      }
    },
    list_product() {
      this.$token_api
        .get("/list-product")
        .then((response) => {
          this.product = response.data.data;
          //console.log(response.data.data)
        })
        .catch((err) => { });
    },
    resetPrice() {
      this.onlyVat3 = 0;
      this.onlyVat7 = 0;
      this.summary = 0;
      this.summaryVat3 = 0;
      this.totalVat7 = 0;
      this.exclude_7 = 0;
      this.SET_ELEM({
        key: "ISVAT2",
        value: false,
      });
      this.SET_ELEM({
        key: "ISVAT",
        value: false,
      });
    },
    save_price() {
      let vat3 = this.GET_INVOICE.ISVAT2;
      let vat7 = this.GET_INVOICE.ISVAT;
      let sp_option = this.sp_option
      this.sumProductValue(vat7, vat3, sp_option);
    },
    select_customer(item) {
      //console.log(item)
      this.$token_api
        .post("/customer-ref-bills", { CUSTOMER_ID: item.NEWCUSTOMER_ID })
        .then(async (response) => {
          let data = response.data.data[0];
          if (response.data.data.length > 0) {
            const bill_ref = await new Response(data.REF_ID).json();
            this.list_ref = bill_ref.length > 0 ? bill_ref : []
            this.SET_ELEM({
              key: "CUSTOMER_TAX_ID",
              value: data.CUSTOMER_TAX_ID,
            });
            this.SET_ELEM({
              key: "CUSTOMER_ADDRESS",
              value: data.CUSTOMER_ADDRESS,
            });
            this.SET_ELEM({
              key: "CUSTOMER_BRANCH",
              value: data.CUSTOMER_BRANCH,
            });
            this.SET_ELEM({
              key: "CUSTOMER_PROVINCE",
              value: data.CUSTOMER_PROVINCE,
            });
            this.SET_ELEM({
              key: "CUSTOMER_DISTRICT",
              value: data.CUSTOMER_DISTRICT,
            });
            this.SET_ELEM({
              key: "CUSTOMER_SUBDISTRICT",
              value: data.CUSTOMER_SUBDISTRICT,
            });
            this.SET_ELEM({
              key: "CUSTOMER_ZIPCODE",
              value: data.CUSTOMER_ZIPCODE,
            });
            this.$store.dispatch("Invoice/reset_product_list");
          }
        })
        .catch((err) => { });
    },
    vat3_option(item) {
      let vat3 = this.GET_INVOICE.ISVAT2;
      let vat7 = this.GET_INVOICE.ISVAT;
      let sp_option = this.sp_option

      this.sumProductValue(vat7, vat3, sp_option);
    },
    checked_vat7(item) {
      let vat3 = this.GET_INVOICE.ISVAT2;
      let vat7 = this.GET_INVOICE.ISVAT;
      let sp_option = this.sp_option
      this.actual_pay = 0
      this.SET_ELEM({ key: "DISCOUNT_VALUE", value: "" })

      this.sumProductValue(vat7, vat3, sp_option);
    },
    checked_vat3(item) {
      this.isVat3 = item;
      let vat3 = this.GET_INVOICE.ISVAT2;
      let vat7 = this.GET_INVOICE.ISVAT;
      let sp_option = this.sp_option
      this.actual_pay = 0
      this.sumProductValue(vat7, vat3, sp_option);
      if (item) {
        this.SET_ELEM({ key: "VAT_VALUE2", value: "3%" })
      } else {
        this.SET_ELEM({ key: "VAT_VALUE2", value: "" })
      }
      this.SET_ELEM({ key: "DISCOUNT_VALUE", value: "" })



    },
    price_option(item) {
      this.resetPrice();
      this.$store.dispatch("Invoice/reset_product_list");
      this.vat_option = item;
    },
    sumProductValue(vat7, vat3, p_option) {
      let product = this.GET_PRODUCT;
      let sp_value = this.split_value
      let sp_price = this.splitPrice
      let sum = product.reduce(
        (acc, item) => parseFloat(acc) + parseFloat(item.PRICE * item.AMOUT),
        0
      );
      let sum_split = 0
      if (p_option == "จำนวนเงิน") {
        if (sp_price <= sum) {
          this.splitPrice = sp_value

        } else {
          this.split_value = 0
          this.splitPrice = 0
        }

      } else if (p_option == "เปอร์เซ็นต์") {
        if (sp_price <= sum) {
          this.splitPrice = (sum * (sp_value / 100))

        } else {
          this.split_value = 0
          this.splitPrice = 0
        }
      }
      this.isSplit ? sum_split = parseFloat(this.splitPrice) : sum_split = parseFloat(sum)

      if (vat7 && !vat3) {
        this.onlyVat7 = (sum_split * 7) / 100;
        this.totalVat7 = sum_split + (sum_split * 7) / 100;
        this.onlyVat3 = 0;
        this.summaryVat3 = 0;
        this.SET_ELEM({ key: "VAT_VALUE", value: "7%" })
        this.SET_ELEM({ key: "VAT_VALUE2", value: "" })
        this.actual_pay = this.totalVat7 
      } else if (!vat7 && vat3) {
        this.onlyVat3 = (sum_split * parseFloat(this.vat3_value)) / 100;
        this.onlyVat7 = 0;
        this.totalVat7 = sum_split;
        this.SET_ELEM({ key: "VAT_VALUE", value: "7%" })
        this.SET_ELEM({ key: "VAT_VALUE2", value: this.vat3_value })
        // console.log(this.onlyVat3)
        this.summaryVat3 = parseFloat(this.totalVat7) - parseFloat(this.onlyVat3);
        this.actual_pay = this.summaryVat3
      } else if (vat7 && vat3) {

        this.onlyVat3 = (sum_split * parseFloat(this.vat3_value)) / 100;
        this.onlyVat7 = (sum_split * 7) / 100;
        this.totalVat7 = sum_split + (sum_split * 7) / 100;
        this.summaryVat3 = parseFloat(this.totalVat7) - parseFloat(this.onlyVat3);
        this.actual_pay = this.summaryVat3
        this.SET_ELEM({ key: "VAT_VALUE", value: "7%" })
        this.SET_ELEM({ key: "VAT_VALUE2", value: this.vat3_value })
      } else {
        this.onlyVat3 = 0;
        this.onlyVat7 = 0;
        this.totalVat7 = sum_split;
        this.SET_ELEM({ key: "VAT_VALUE", value: "" })
        this.SET_ELEM({ key: "VAT_VALUE2", value: "" })
        this.actual_pay = this.totalVat7
      }
      this.summary = sum;


      return sum_split;
    },
    sumCol(index) {
      let product = this.GET_PRODUCT;
      return parseFloat(product[index].PRICE * product[index].AMOUT);
    },
    total_noVat() {
      return this.sumProductValue();
    },
    changeUnit() {
      let vat3 = this.GET_INVOICE.ISVAT2;
      let vat7 = this.GET_INVOICE.ISVAT;
      let sp_option = this.sp_option
      this.sumProductValue(vat7, vat3, sp_option);
    },
    changePrice() {
      let vat3 = this.GET_INVOICE.ISVAT2;
      let vat7 = this.GET_INVOICE.ISVAT;
      let sp_option = this.sp_option

      this.sumProductValue(vat7, vat3, sp_option);
    },
    add_product() {
      this.$store.dispatch("Invoice/add_product_list", {
        INDEX: 0,
        NAME: "",
        DETAIL: "",
        AMOUT: 1,
        UNIT: "",
        PRICE: 0,
        TOTAL_PRICE: 0,
      });
    },
    async delete_product(item) {
      this.$swal({
        title: "ต้องการลบสินค้าหรือไม่",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then(async (result) => {
        if (result.value) {
          await this.$token_api.delete("/delete-invoice-product", { data: { INVOICE_ID: this.header, PRODUCT_ID: item.PID } })
          this.$store.dispatch("Invoice/remove_product_list", item);

        }
      })


    },

    back() {
      // console.log(process.env.host)
      let _from = this.previousRoute;
      if (_from) {
        window.location.href = `${this.$global_link}${_from.path}`;
      } else {
        window.location.href = `${this.$global_link}`;
      }
    },
    check_split_value() {
      let quotation = this.GET_INVOICE;
      this.LOADER(true)
      quotation.SPLIT_OPTION = this.sp_option
      quotation.SPLIT_VALUE = this.split_value
      quotation.PAID_VAT = this.totalVat7
      // this.save_price()
      this.SET_ELEM({ key: "ACTUAL_PAY", value: this.actual_pay })
      this.SET_ELEM({ key: "DOC_STATUS", value: "อนุมันติ" })
      if (quotation.SPLIT_PAY == 1) {
        quotation.PAID_NO_VAT = this.splitPrice
        if (this.sp_option == "เปอร์เซ็นต์") {
          if (this.split_value <= 0 || this.split_value > 100 || this.split_value > parseInt(quotation.PREVIOUS_VALUE)) {
            this.$swal("กรอกข้อมูลให้ครบถ้วน", "จำนวนเปอร์เซ็นต์ที่แบ่งจ่าย ต้องมากกว่า 0% และไม่เกิน 100%", "warning");
            this.LOADER(false)
            return false
          } else {
            return true

          }
        } else {
          if (this.split_value <= 0 || this.split_value > this.summary || this.split_value > parseInt(quotation.PREVIOUS_VALUE)) {
            this.$swal("กรอกข้อมูลให้ครบถ้วน", "จำนวนเปอร์เซ็นต์ที่แบ่งจ่าย ต้องมากกว่า 0% และไม่เกิน 100%", "warning");
            this.LOADER(false)
            return false
          } else {
            return true

          }
        }

      } else {
        quotation.PAID_NO_VAT = this.summary
        return true

      }

    },
    insert_data() {
      this.LOADER(true)
      let data = this.GET_INVOICE
      data.DOC_DATE = moment(data.CREATED_AT).format("DD/MM/YYYY")
      let quotation_list = {
        PACKAGE: this.GET_PRODUCT,
        DATA: this.GET_INVOICE
      };
      //console.log(quotation_list)
      if (this.check_split_value()) {
        this.$token_api
          .post("/insert-duplicate-invoice", quotation_list)
          .then((response) => {
            this.$swal({
              title: "สำเร็จ",
              text: "สร้างใบกำกับภาษี/ใบเสร็จรับเงิน",
              timer: 2000,
              icon: "success"
            }).then((res) => {
              this.$store.dispatch("Invoice/reset");
              this.LOADER(false)
              this.dialog = false
              this.back()
            });

          })
          .catch((err) => {
            this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
            this.LOADER(false)
          });
      }
      //  this.LOADER(false)

    },
    edit() {
      let data = this.GET_INVOICE
      data.DOC_DATE = moment(data.CREATED_AT).format("DD/MM/YYYY")
      let quotation_list = {
        PACKAGE: this.GET_PRODUCT,
        DATA: this.GET_INVOICE
      };

      if (this.check_split_value()) {
        this.$token_api
          .post("/insert-duplicate-invoice", quotation_list)
          .then((response) => {
            this.$swal({
              title: "สำเร็จ",
              text: "แก้ไขใบวางบิล/แจ้งหนี้สำเร็จ",
              timer: 2000,
              icon: "success"
            }).then((res) => {
              this.$store.dispatch("Invoice/reset");
              this.LOADER(false)
              this.back()
            });

          })
          .catch((err) => {
            this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
            this.LOADER(false)
          });
      }

    }
  },

};
</script>

